export default [
    {
        path: '/pages/goods/storeOrderCartDetail',
        name: '/pages/goods/storeOrderCartDetail',
        meta: { title: '订单详情' },
        component: () => import('@/views/goods/storeOrderCartDetail.vue')
    },
    {
        path: '/pages/goods/UpShopHouseDetail',
        name: '/pages/goods/UpShopHouseDetail',
        component: () => import('@/views/goods/UpShopHouseDetail.vue')
    },
    {
        path: '/pages/goods/upShopHouseInManage',
        name: '/pages/goods/upShopHouseInManage',
        component: () => import('@/views/goods/upShopHouseInManage.vue')
    },
    {
        path: '/pages/goods/upShopHouseManage',
        name: '/pages/goods/upShopHouseManage',
        meta: { title: '进货单' },
        component: () => import('@/views/goods/upShopHouseManage.vue')
    },
    {
        path: '/pages/goods/userExpeditingDelivery',
        name: '/pages/goods/userExpeditingDelivery',
        meta: { title: '客户催单' },
        component: () => import('@/views/goods/userExpeditingDelivery.vue')
    },
    {
        path: '/pages/goods/shopSettingManage',
        name: '/pages/goods/shopSettingManage',
        meta: { title: '店铺配置' },
        component: () => import('@/views/goods/shopSettingManage.vue')
    },
    {
        path: '/pages/goods/shopVipUserAccount',
        name: '/pages/goods/shopVipUserAccount',
        meta: { title: '会员账户' },
        component: () => import('@/views/goods/shopVipUserAccount.vue')
    },
    {
        path: '/pages/goods/shopVisitManage',
        name: '/pages/goods/shopVisitManage',
        meta: { title: '店铺访问' },
        component: () => import('@/views/goods/shopVisitManage.vue')
    },
    {
        path: '/pages/goods/shopCommunityManage',
        name: '/pages/goods/shopCommunityManage',
        meta: { title: '店铺小区' },
        component: () => import('@/views/goods/shopCommunityManage.vue')
    },
    {
        path: '/pages/goods/shopHouseManage',
        name: '/pages/goods/shopHouseManage',
        meta: { title: '仓库管理' },
        component: () => import('@/views/goods/shopHouseManage.vue')
    },
    {
        path: '/pages/goods/shopReturnAddressManage',
        name: '/pages/goods/shopReturnAddressManage',
        meta: { title: '退货地址' },
        component: () => import('@/views/goods/shopReturnAddressManage.vue')
    },
    {
        path: '/pages/goods/sellingCostManage',
        name: '/pages/goods/sellingCostManage',
        meta: { title: '销售成本表' },
        component: () => import('@/views/goods/sellingCostManage.vue')
    },
    {
        path: '/pages/goods/shopAccountDetailManage',
        name: '/pages/goods/shopAccountDetailManage',
        meta: { title: '财务明细' },
        component: () => import('@/views/goods/shopAccountDetailManage.vue')
    },
    {
        path: '/pages/goods/shopAccountManage',
        name: '/pages/goods/shopAccountManage',
        meta: { title: '收款账户' },
        component: () => import('@/views/goods/shopAccountManage.vue')
    },
    {
        path: '/pages/goods/shopAppraiseManage',
        name: '/pages/goods/shopAppraiseManage',
        meta: { title: '商品评论' },
        component: () => import('@/views/goods/shopAppraiseManage.vue')
    },
    {
        path: '/pages/goods/shopAuditManage',
        name: '/pages/goods/shopAuditManage',
        meta: { title: '变更记录' },
        component: () => import('@/views/goods/shopAuditManage.vue')
    },
    {
        path: '/pages/goods/viewShopAudit',
        name: '/pages/goods/viewShopAudit',
        component: () => import('@/views/goods/viewShopAudit.vue')
    },
    {
        path: '/pages/goods/queryStockManage',
        name: '/pages/goods/queryStockManage',
        meta: { title: '库存查询' },
        component: () => import('@/views/goods/queryStockManage.vue')
    },
    {
        path: '/pages/goods/queryWarnStock',
        name: '/pages/goods/queryWarnStock',
        meta: { title: '库存警告' },
        component: () => import('@/views/goods/queryWarnStock.vue')
    },
    {
        path: '/pages/goods/recommendGoodsManage',
        name: '/pages/goods/recommendGoodsManage',
        component: () => import('@/views/goods/recommendGoodsManage.vue')
    },
    {
        path: '/pages/goods/resourceSupplierManage',
        name: '/pages/goods/resourceSupplierManage',
        meta: { title: '供应商' },
        component: () => import('@/views/goods/resourceSupplierManage.vue')
    },
    {
        path: '/pages/goods/sellingCostDetailManage',
        name: '/pages/goods/sellingCostDetailManage',
        meta: { title: '销售成本明细' },
        component: () => import('@/views/goods/sellingCostDetailManage.vue')
    },
    {
        path: '/pages/goods/productPriceRuleManage',
        name: '/pages/goods/productPriceRuleManage',
        meta: { title: '商品定价' },
        component: () => import('@/views/goods/productPriceRuleManage.vue')
    },
    {
        path: '/pages/goods/productSpecManage',
        name: '/pages/goods/productSpecManage',
        component: () => import('@/views/goods/productSpecManage.vue')
    },
    {
        path: '/pages/goods/productStockManage',
        name: '/pages/goods/productStockManage',
        component: () => import('@/views/goods/productStockManage.vue')
    },
    {
        path: '/pages/goods/publicWeChatManage',
        name: '/pages/goods/publicWeChatManage',
        component: () => import('@/views/goods/publicWeChatManage.vue')
    },
    {
        path: '/pages/goods/productDetail',
        name: '/pages/goods/productDetail',
        component: () => import('@/views/goods/productDetail.vue')
    },
    {
        path: '/pages/goods/productImport',
        name: '/pages/goods/productImport',
        meta: { title: '商品导入' },
        component: () => import('@/views/goods/productImport.vue')
    },
    {
        path: '/pages/goods/productLabelManage',
        name: '/pages/goods/productLabelManage',
        meta: { title: '打标商品' },
        component: () => import('@/views/goods/productLabelManage.vue')
    },
    {
        path: '/pages/goods/productManage',
        name: '/pages/goods/productManage',
        meta: { title: '商品管理' },
        component: () => import('@/views/goods/productManage.vue')
    },
    {
        path: '/pages/goods/myHousekeepingDispatchManage',
        name: '/pages/goods/myHousekeepingDispatchManage',
        meta: { title: '服务已办' },
        component: () => import('@/views/goods/myHousekeepingDispatchManage.vue')
    },
    {
        path: '/pages/goods/outOrderManage',
        name: '/pages/goods/outOrderManage',
        meta: { title: '出库单' },
        component: () => import('@/views/goods/outOrderManage.vue')
    },
    {
        path: '/pages/goods/PrintSmallOrder',
        name: '/pages/goods/PrintSmallOrder',
        component: () => import('@/views/goods/PrintSmallOrder.vue')
    },
    {
        path: '/pages/goods/productCategoryManage',
        name: '/pages/goods/productCategoryManage',
        meta: { title: '商品分组' },
        component: () => import('@/views/goods/productCategoryManage.vue')
    },
    {
        path: '/pages/goods/groupBuyProductManage',
        name: '/pages/goods/groupBuyProductManage',
        component: () => import('@/views/goods/groupBuyProductManage.vue')
    },
    {
        path: '/pages/goods/GroupBuySettingManage',
        name: '/pages/goods/GroupBuySettingManage',
        component: () => import('@/views/goods/GroupBuySettingManage.vue')
    },
    {
        path: '/pages/goods/inoutOrderManage',
        name: '/pages/goods/inoutOrderManage',
        meta: { title: '入库单' },
        component: () => import('@/views/goods/inoutOrderManage.vue')
    },
    {
        path: '/pages/goods/labelManage',
        name: '/pages/goods/labelManage',
        meta: { title: '商品标签' },
        component: () => import('@/views/goods/labelManage.vue')
    },
    {
        path: '/pages/goods/groupBuyBatchManage',
        name: '/pages/goods/groupBuyBatchManage',
        component: () => import('@/views/goods/groupBuyBatchManage.vue')
    },
    {
        path: '/pages/goods/groupBuyManage',
        name: '/pages/goods/groupBuyManage',
        component: () => import('@/views/goods/groupBuyManage.vue')
    },
    {
        path: '/pages/goods/getSalesInfoManage',
        name: '/pages/goods/getSalesInfoManage',
        meta: { title: '销售明细' },
        component: () => import('@/views/goods/getSalesInfoManage.vue')
    },
    {
        path: '/pages/goods/getSalesRankingInfoManage',
        name: '/pages/goods/getSalesRankingInfoManage',
        meta: { title: '销售排行' },
        component: () => import('@/views/goods/getSalesRankingInfoManage.vue')
    },
    {
        path: '/pages/goods/goldBusinessManage',
        name: '/pages/goods/goldBusinessManage',
        component: () => import('@/views/goods/goldBusinessManage.vue')
    },
    {
        path: '/pages/goods/goodCashier',
        name: '/pages/goods/goodCashier',
        meta: { title: '收银台' },
        component: () => import('@/views/goods/goodCashier.vue')
    },
    {
        path: '/pages/goods/finishHousekeepingPool',
        name: '/pages/goods/finishHousekeepingPool',
        component: () => import('@/views/goods/finishHousekeepingPool.vue')
    },
    {
        path: '/pages/goods/getInoutInfoManage',
        name: '/pages/goods/getInoutInfoManage',
        meta: { title: '进货明细' },
        component: () => import('@/views/goods/getInoutInfoManage.vue')
    },
    {
        path: '/pages/goods/getInStockInfoManage',
        name: '/pages/goods/getInStockInfoManage',
        meta: { title: '进货统计' },
        component: () => import('@/views/goods/getInStockInfoManage.vue')
    },
    {
        path: '/pages/goods/doOrderDetailOut',
        name: '/pages/goods/doOrderDetailOut',
        component: () => import('@/views/goods/doOrderDetailOut.vue')
    },
    {
        path: '/pages/goods/downShopHouseManage',
        name: '/pages/goods/downShopHouseManage',
        meta: { title: '进货退货' },
        component: () => import('@/views/goods/downShopHouseManage.vue')
    },
    {
        path: '/pages/goods/downShopHouseOutManage',
        name: '/pages/goods/downShopHouseOutManage',
        component: () => import('@/views/goods/downShopHouseOutManage.vue')
    },
    {
        path: '/pages/goods/editProduct',
        name: '/pages/goods/editProduct',
        component: () => import('@/views/goods/editProduct.vue')
    },
    {
        path: '/pages/goods/feePrintSpecManage',
        name: '/pages/goods/feePrintSpecManage',
        component: () => import('@/views/goods/feePrintSpecManage.vue')
    },
    {
        path: '/pages/goods/couponShopPoolManage',
        name: '/pages/goods/couponShopPoolManage',
        component: () => import('@/views/goods/couponShopPoolManage.vue')
    },
    {
        path: '/pages/goods/distributionModeManage',
        name: '/pages/goods/distributionModeManage',
        component: () => import('@/views/goods/distributionModeManage.vue')
    },
    {
        path: '/pages/goods/DoAllocationOrderIn',
        name: '/pages/goods/DoAllocationOrderIn',
        component: () => import('@/views/goods/DoAllocationOrderIn.vue')
    },
    {
        path: '/pages/goods/DoOrderDetailIn',
        name: '/pages/goods/DoOrderDetailIn',
        component: () => import('@/views/goods/DoOrderDetailIn.vue')
    },
    {
        path: '/pages/goods/centralizedPurchase',
        name: '/pages/goods/centralizedPurchase',
        component: () => import('@/views/goods/centralizedPurchase.vue')
    },
    {
        path: '/pages/goods/chainInoutOrderManage',
        name: '/pages/goods/chainInoutOrderManage',
        meta: { title: '订单' },
        component: () => import('@/views/goods/chainInoutOrderManage.vue')
    },
    {
        path: '/pages/goods/chainSupplier',
        name: '/pages/goods/chainSupplier',
        meta: { title: '集采中心' },
        component: () => import('@/views/goods/chainSupplier.vue')
    },
    {
        path: '/pages/goods/couponDetailManage',
        name: '/pages/goods/couponDetailManage',
        component: () => import('@/views/goods/couponDetailManage.vue')
    },
    {
        path: '/pages/goods/couponShopPoolDetailManage',
        name: '/pages/goods/couponShopPoolDetailManage',
        component: () => import('@/views/goods/couponShopPoolDetailManage.vue')
    },
    {
        path: '/pages/goods/buyGoldSend',
        name: '/pages/goods/buyGoldSend',
        component: () => import('@/views/goods/buyGoldSend.vue')
    },
    {
        path: '/pages/goods/buyGoldSendParking',
        name: '/pages/goods/buyGoldSendParking',
        component: () => import('@/views/goods/buyGoldSendParking.vue')
    },
    {
        path: '/pages/goods/AssetInventoryInStock',
        name: '/pages/goods/AssetInventoryInStock',
        component: () => import('@/views/goods/AssetInventoryInStock.vue')
    },
    {
        path: '/pages/goods/assetInventoryManage',
        name: '/pages/goods/assetInventoryManage',
        meta: { title: '资产盘点' },
        component: () => import('@/views/goods/assetInventoryManage.vue')
    },
    {
        path: '/pages/goods/buyGold',
        name: '/pages/goods/buyGold',
        meta: { title: '购买金币' },
        component: () => import('@/views/goods/buyGold.vue')
    },
    {
        path: '/pages/goods/applyReturnOrderrCartManage',
        name: '/pages/goods/applyReturnOrderrCartManage',
        component: () => import('@/views/goods/applyReturnOrderrCartManage.vue')
    },
    {
        path: '/pages/goods/AssetInventoryEdit',
        name: '/pages/goods/AssetInventoryEdit',
        component: () => import('@/views/goods/AssetInventoryEdit.vue')
    },
    {
        path: '/pages/goods/assetInventoryIn',
        name: '/pages/goods/assetInventoryIn',
        component: () => import('@/views/goods/assetInventoryIn.vue')
    },
    {
        path: '/pages/goods/allocationOrderIn',
        name: '/pages/goods/allocationOrderIn',
        component: () => import('@/views/goods/allocationOrderIn.vue')
    },
    {
        path: '/pages/goods/allocationOrderManage',
        name: '/pages/goods/allocationOrderManage',
        meta: { title: '仓库调拨' },
        component: () => import('@/views/goods/allocationOrderManage.vue')
    },
    {
        path: '/pages/goods/ApplyReturnOrderManage',
        name: '/pages/goods/ApplyReturnOrderManage',
        component: () => import('@/views/goods/ApplyReturnOrderManage.vue')
    },
    {
        path: '/pages/goods/AccountBankManage',
        name: '/pages/goods/AccountBankManage',
        meta: { title: '开户行管理' },
        component: () => import('@/views/goods/AccountBankManage.vue')
    },
    {
        path: '/pages/goods/AccountBondObjManage',
        name: '/pages/goods/AccountBondObjManage',
        component: () => import('@/views/goods/AccountBondObjManage.vue')
    },
    {
        path: '/pages/goods/accountWithdrawalApplyManage',
        name: '/pages/goods/accountWithdrawalApplyManage',
        meta: { title: '账户提现' },
        component: () => import('@/views/goods/accountWithdrawalApplyManage.vue')
    },
    {
        path: '/pages/goods/addProduct',
        name: '/pages/goods/addProduct',
        component: () => import('@/views/goods/addProduct.vue')
    },
    {
        path: '/pages/goods/adminProduct',
        name: '/pages/goods/adminProduct',
        meta: { title: '上架商品' },
        component: () => import('@/views/goods/adminProduct.vue')
    }
] 